import clsx from "clsx";
import { TagGuaranteed } from "./TagGuaranteed";

type Props = {
  className?: string;
  untilGaranti: number | null;
  garanti: boolean;
};
export const TagUntilGuaranteed = ({ className, untilGaranti, garanti }: Props) => {
  if ((untilGaranti === 2 || untilGaranti === 1) && !garanti) {
    return (
      <div className={clsx("inline-block py-1 px-1.5 bg-[#15A4A4] rounded-sm text-white h-[34px]", className)}>
        <p className="text-xs/[14px] font-bold text-center">Départ garanti</p>
        <p className="text-[10px]/[12px] font-medium text-center">
          {untilGaranti === 2 && "dans 2 inscrits"}
          {untilGaranti === 1 && "dans 1 inscrit"}
        </p>
      </div>
    );
  }

  if ((untilGaranti !== null && untilGaranti < 1) || garanti) return <TagGuaranteed className={className} />;

  return null;
};
